export enum ProgramUpdateErrors {
	SESSION_ORDER_CHANGED = "SESSION_ORDER_CHANGED",
	SESSION_DONE_CONTENT_CHANGED = "SESSION_DONE_CONTENT_CHANGED",
}

export class SessionOrderChangedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}

export class SessionDoneContentChangedError extends Error {
	public constructor(message?: string) {
		super(message);
	}
}
